<template>
	<div class="user-address">
		<b-spinner variant="success"
		    class="spinStyle"
		    v-show="showSpin"
		    label="Text Centered"></b-spinner>
		<b-table id="address-table"
		    :fields="addressInfoTab.addressFields"
		    :items="addressInfoTab.addressItems"
		    small
		    bordered
		    hover
		    show-empty
		    empty-text="没有找到匹配的记录"
		    caption-top>
		    <template slot="table-caption">
		        <b-button style="float:right;"
		            size="sm"
					variant="success"
		            v-on:click="onAddMemberAddress()">
		            新增收货地址
		        </b-button>
		    </template>
		    <template v-slot:cell(actionButton)="row">
		        <a href="#"
		            v-on:click="onModifyAddress(row)">编辑</a> /
		        <a href="#"
		            v-on:click="onDeleteAddress(row)">删除</a>
		    </template>
		    <template v-slot:cell(memberDeliveryAddressDefault)="row">
		        <span>{{row.item.memberDeliveryAddressDefault === 1? '是':'否' }}</span>
		    </template>
		</b-table>	
		
		
		<!-- 会员地址对话框 -->
		<b-modal id="addressInfoTab.addressModel"
		    v-model="addressInfoTab.addressModel.show"
		    :title="addressInfoTab.addressModel.title"
		    no-close-on-backdrop>
		    <b-row align-v="center">
		        <b-col lg="12"
		            class="registerInfo">
		            <b-form>
		                <b-form-group label="会员账号:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm">
		                    <b-form-input v-model="addressInfoTab.addressModel.memberName"
		                        size="sm"
		                        readonly
		                        required
		                        placeholder="必填"></b-form-input>
		                </b-form-group>
		                <b-form-group label="联系人:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm">
		                    <b-form-input v-model="addressInfoTab.addressModel.memberDeliveryAddressContacts"
		                        size="sm"
		                        required
		                        placeholder="必填"></b-form-input>
		                </b-form-group>
		                <b-form-group label="手机:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm">
		                    <b-form-input @blur="memberPhoneBlur(addressInfoTab.addressModel.memberDeliveryAddressPhone)" v-model="addressInfoTab.addressModel.memberDeliveryAddressPhone"
		                        size="sm"
		                        required
		                        placeholder="必填"></b-form-input>
		                </b-form-group>
						
		                <b-form-group label="配送类型:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm">
		                    <b-form-radio-group 
		                    size="sm" v-model="addressInfoTab.addressModel.memberDeliveryAddressType">
		                        <b-form-radio value="自提" name="自提" >自提</b-form-radio>
		                        <b-form-radio value="收货" name="收货" >收货</b-form-radio>
		                    </b-form-radio-group>
		                </b-form-group>
						
		                 <b-form-group label="省市县:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm" v-if="addressInfoTab.addressModel.memberDeliveryAddressType =='收货'">
		                   <b-form-select v-model="addressInfoTab.addressModel.memberDeliveryAddressProvinceUuid"
		                        size="sm"
		                        class="formSelect"
		                        @change="onProviceSelectChange">
		                        <option value="">选择省份</option>
		                        <option :value="item.regionUuid"
		                            v-for="item in provinceList"
		                            :key="item.regionUuid">
		                            {{item.regionName}}
		                        </option>
		                    </b-form-select>
		                    <b-form-select v-model="addressInfoTab.addressModel.memberDeliveryAddressCityUuid"
		                        size="sm"
		                        class="formSelect"
		                        @change="onCitySelectChange">
		                        <option value="">选择城市</option>
		                        <option :value="item.regionUuid"
		                            v-for="item in cityList"
		                            :key="item.regionUuid">
		                            {{item.regionName}}
		                        </option>
		                    </b-form-select>
		                    <b-form-select v-model="addressInfoTab.addressModel.memberDeliveryAddressDistUuid"
		                        size="sm"
		                        class="formSelect"
		                        @change="onDistSelectChangne">
		                        <option value="">选择区县</option>
		                        <option :value="item.regionUuid"
		                            v-for="item in distList"
		                            :key="item.regionUuid">
		                            {{item.regionName}}
		                        </option>
		                    </b-form-select>
		                </b-form-group>
						
		                <b-form-group label="详细地址:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm" v-if="addressInfoTab.addressModel.memberDeliveryAddressType =='收货'">
		                    <b-form-input v-model="addressInfoTab.addressModel.memberDeliveryAddressFull"
		                        size="sm"
		                        placeholder="必填"></b-form-input>
		                </b-form-group>
		                <b-form-group label="转运站:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm" v-else>
		                    <Select v-model="addressInfoTab.addressModel.memberDeliveryAddressStationUuid"
		                        transfer
		                        clearable
		                        filterable>
		                        <Option :value="station.distributionStationUuid"
		                            v-for="station in addressInfoTab.stationList"
		                            :key="station.distributionStationUuid">
		                            {{station.distributionStationCode + " " + station.distributionStationName}}
		                        </Option>
		                    </Select>
		                </b-form-group>
						
		                <b-form-group label="是否默认:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm">
		                    <b-form-radio-group v-model="addressInfoTab.addressModel.memberDeliveryAddressDefault"
		                        size="sm">
		                        <b-form-radio value="1">是</b-form-radio>
		                        <b-form-radio value="0">否</b-form-radio>
		                    </b-form-radio-group>
		                </b-form-group>
		            </b-form>
		        </b-col>
		    </b-row>
		
		    <template slot="modal-footer">
		        <b-button size="sm"
		            variant="success"
		            @click="SaveAddressInfo()">
		            <b-spinner small
		                v-if="addressInfoTab.modifyAddressBusySpin"></b-spinner>
		            保存
		        </b-button>
		        <b-button size="sm"
		            variant="danger"
		            @click="addressInfoTab.addressModel.show = false">
		            取消
		        </b-button>
		    </template>
		</b-modal>
	</div>
</template>

<script>
	import api from '@/api/api';
	import axios from 'axios';
export default{
	data(){
		return{
			showSpin:false,
			addressShow:true,
			stationShow:false,
			 tabIndex: 0,
			 addressInfoTab: {
			     modifyAddressBusySpin: false,
			     addressFields: [
			         { key: 'memberDeliveryAddressContacts', label: '联系人' },
			         { key: 'memberDeliveryAddressPhone', label: '手机' },
			         { key: 'memberDeliveryAddressType', label: '配送类型' },
			         { key: 'province', label: '省' },
			         { key: 'city', label: '市' },
			         { key: 'dist', label: '区' },
			         { key: 'memberDeliveryAddressFull', label: '详细地址' },
			         { key: 'distributionStationName', label: '配送站' },
			         { key: 'memberDeliveryAddressDefault', label: '是否默认' },
			         { key: 'actionButton', label: '操作' }
			     ],
			     stationList: [],
			     selectedStationUuid: '',
			     addressItems: [],
			     addressModel: {
			         show: false,
			         title: '',
			         formEditMode: '',
			         memberDeliveryAddressUuid: '',
			         memberName: '',
			         memberDeliveryAddressCompanyName: '',
			         memberDeliveryAddressContacts: '',
			         memberDeliveryAddressContactNumber: '',
			         memberDeliveryAddressPhone: '',
			         memberDeliveryAddressProvinceUuid: null,
			         memberDeliveryAddressCityUuid: null,
			         memberDeliveryAddressDistUuid: null,
			         memberDeliveryAddressZipCode: '',
			         memberDeliveryAddressDefault: 0,
			         memberDeliveryAddressFull: '',
			         memberDeliveryAddressType: '收货',
			         memberDeliveryAddressStationUuid: ''
			     }
			 },
			 provinceList: [],
			 cityList: [],
			 distList: [],
		}
	},
	mounted() {
		if (!this.checkMemberLogin()) {
			this.$router.push({
				name: 'MemberLogin'
			});
			return;
		};
		
		this.getStationList();
		this.getMemberAddressList();
	},
	methods:{
		getAllRegionList(){
			this.cityList = [];
			this.distList = [];
		    api.webGetAllRegion().then(res => {
		        if (res.code === 0) {
		            this.regionList = res.data.allRegions;
		            this.provinceList = this.regionList.filter(e => {
		                return e.regionType === 1;
		            });
					if (this.addressInfoTab.addressModel.memberDeliveryAddressProvinceUuid) {
					    this.cityList = this.regionList.filter(e => {
					        return e.regionParentUuid === this.addressInfoTab.addressModel.memberDeliveryAddressProvinceUuid;
					    });
					}
					if (this.addressInfoTab.addressModel.memberDeliveryAddressCityUuid) {
					    this.distList = this.regionList.filter(e => {
					        return e.regionParentUuid === this.addressInfoTab.addressModel.memberDeliveryAddressCityUuid;
					    });
					}
		        }
		    });
		},
		// 手机格式检验
		memberPhoneBlur(val) {
		    var memPhone = (/^(13[0-9]|14[1579]|15[0-3,5-9]|16[6]|17[0123456789]|18[0-9]|19[89])\d{8}$/); //手机号码
		    if (!memPhone.test(val)) {
		        this.$bvModal.msgBoxOk("手机号码不符合格式", {
		            title: '提示',
		            buttonSize: 'sm'
		        });
		        return;
		    }
		},
		getMemberRegisterData() {
		    api.getMemberRegisterData({}).then(res => {
		        if (res.code === 0) {
		            this.memberInfoTab.cateManagerRelation = res.data.cateManagerRelation.records;
		            this.memberInfoTab.allPassManagerList = res.data.cateManagerRelation.allPassMangers;
		            this.regionList = res.data.allRegions.allRegions;
		            this.provinceList = this.regionList.filter(e => {
		                return e.regionType === 1;
		            });
		            this.cityList = this.regionList.filter(e => {
		                return e.regionType === 2;
		            });
		            this.distList = this.regionList.filter(e => {
		                return e.regionType === 3;
		            });
		        }
		    });
		},
		getStationList() {
			api.webGetAllDistributionStationList({}).then(res => {
				if (res.code === 0) {
					this.addressInfoTab.stationList = res.data.distributionStations;
				}
			});
		},
		onProviceSelectChange(value) {
		    this.cityList = [];
		    this.distList = [];
		    if (value) {
		        this.cityList = this.regionList.filter(e => {
		            return e.regionParentUuid === value;
		        });
		    }
		    this.addressInfoTab.addressModel.memberDeliveryAddressProvinceUuid = value;
		
		},
		onCitySelectChange(value) {
		    this.distList = [];
		    if (value) {
		        this.distList = this.regionList.filter(e => {
		            return e.regionParentUuid === value;
		        });
		    }
		    this.addressInfoTab.addressModel.memberDeliveryAddressCityUuid = value;
		},
		onDistSelectChangne(value) {
		    this.addressInfoTab.addressModel.memberDeliveryAddressDistUuid = value;
		},
		onSavePersonInfo() {
		    this.updatePersonInfo();
		},
		onAddMemberAddress() {
		    this.addressInfoTab.addressModel.title = "新增地址";
		    this.addressInfoTab.addressModel.memberDeliveryAddressUuid = '';
		    this.addressInfoTab.addressModel.memberName = this.getLoginCookieName();
		    this.addressInfoTab.addressModel.formEditMode = "CREATE";
		    this.addressInfoTab.addressModel.memberDeliveryAddressCompanyName = "";
		    this.addressInfoTab.addressModel.memberDeliveryAddressContacts = "";
		    this.addressInfoTab.addressModel.memberDeliveryAddressContactNumber = "";
		    this.addressInfoTab.addressModel.memberDeliveryAddressPhone = "";
		    this.addressInfoTab.addressModel.memberDeliveryAddressProvinceUuid = "";
		    this.addressInfoTab.addressModel.memberDeliveryAddressCityUuid = "";
		    this.addressInfoTab.addressModel.memberDeliveryAddressDistUuid = "";
		    this.addressInfoTab.addressModel.memberDeliveryAddressZipCode = "";
		    this.addressInfoTab.addressModel.memberDeliveryAddressDefault = 0;
		    this.addressInfoTab.addressModel.memberDeliveryAddressFull = "";
		    this.addressInfoTab.addressModel.memberDeliveryAddressType = "收货";
		    this.addressInfoTab.addressModel.memberDeliveryAddressStationUuid = "";
		    this.addressInfoTab.addressModel.show = true;
			this.getAllRegionList();
		},
		onModifyAddress(row) {
		    Object.assign(this.addressInfoTab.addressModel, row.item);
		    this.addressInfoTab.addressModel.title = "修改地址";
		    this.addressInfoTab.addressModel.memberDeliveryAddressUuid = row.item.memberDeliveryAddressUuid;
		    this.addressInfoTab.addressModel.memberName = this.getLoginCookieName();
		    this.addressInfoTab.addressModel.formEditMode = "MODIFY";
		    this.addressInfoTab.addressModel.show = true;
			this.getAllRegionList();
		},
		onDeleteAddress(row) {
		    this.$bvModal.msgBoxConfirm('是否确认删除该地址？', {
		        size: 'sm',
		        buttonSize: 'sm',
		        okVariant: 'danger',
		        okTitle: '是',
		        cancelTitle: '否'
		    }).then(value => {
		        if (value) {
		            api.webDeleteMemberDeliveryAddress({
		                memberDeliveryAddressUuid: row.item.memberDeliveryAddressUuid
		            }).then(res => {
		                if (res.code === 0) {
		                    this.getMemberAddressList();
		                }
		            });
		        }
		    });
		},
		SaveAddressInfo() {
		    this.addressInfoTab.modifyAddressBusySpin = true;
		    api.webSaveMemberDeliveryAddress(this.addressInfoTab.addressModel).then(res => {
		        this.addressInfoTab.modifyAddressBusySpin = false;
		        if (res.code === 0) {
		            this.$bvModal.msgBoxOk('信息保存成功', {
		                title: '提示',
		                buttonSize: 'sm'
		            });
		            this.addressInfoTab.addressModel.show = false;
		            //记录默认地址
		            if (res.data.address.memberDeliveryAddressDefault === 1) {
		                // this.setAddressStorage(res.data.address);
						this.$cookies.set('km_seed_address', res.data.address.memberDeliveryAddressUuid);
		            }
		            this.getMemberAddressList();
		        }
		    });
		},
		getMemberAddressList() {
		    if (this.checkMemberLogin()) {
		        api.webGetMemberDeliveryAddressList().then(res => {
		            if (res.code === 0) {
		                this.addressInfoTab.addressItems = res.data.addresses;
		            }
		        });
		    }
		}
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/view/member/user-address.vue